import DragonbonesComponent from '../../../Component/Dragonbones';
import CardComponent from '../../../Component/Level/Card';
import CardModifierComponent from '../../../Component/Level/CardModifier';
import SpriteComponent from '../../../Component/Render/Sprite';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { CardStatus } from '../../../Prototype/Level/Card/CardStatus';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { ICardModifierData } from '../../../Prototype/Level/Card/ICardModifierData';
import { IGameState } from '../../../State/Game/IGameState';
import { MathHelper } from '../../../Utility/MathHelper';
import { Random } from '../../../Utility/Random';
import { StartAnimation } from '../../Animation/AnimationHelper';
import { AUDIO_HAZARD_BOMB_COUNT } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';
import { StartAudio } from '../../Audio/AudioHelper';
import CardSystem from '../CardSystem';
import BaseCardHandler from './BaseCardHandler';

export default class ValueCardHandler extends BaseCardHandler {
    public handleCardInPlay(state: IGameState, cardSystem: CardSystem) {
        super.handleCardInPlay(state, cardSystem);

        const cardData = state.levelState.cardsState.cards[this.card.id];

        // Value change.
        if (cardData.value !== this.cardComponent.value) {
            this.card
                .getChildByName('cardFrontSprite')
                .getComponent(SpriteComponent).texture = `card${cardData.value +
                1}`;

            this.cardComponent.value = cardData.value;
        }

        // Update all modifiers.
        const modContainer = this.card.getChildByName('modifierContainer');

        if (cardData.faceUp) {
            this.setCardModifiersVisible(cardData.modifiers.length > 0);
        }

        cardData.modifiers.forEach((modifier: ICardModifierData) => {
            const modifierGameObject = modContainer.getChildByName(
                modifier.type.toString()
            );

            if (!modifierGameObject) {
                // TODO: Should we add the modifier if it's missing?
                return;
            }

            const modifierComponent = modifierGameObject.getComponent(
                CardModifierComponent
            );

            switch (modifier.type) {
                case CardModifierType.fog:
                    const animation = ['fog03', 'fog02', 'fog01'][
                        MathHelper.pingPong(modifier.properties.plays, 2)
                    ];

                    const fogContainer = modifierGameObject.find(
                        'fogContainer'
                    );

                    const db = fogContainer.getComponent(DragonbonesComponent);
                    if (db.animationName !== animation) {
                        StartAnimation(fogContainer, 'DragonbonesFadeIn', {
                            animationName: animation,
                            fadeInTime: 0.5,
                            progress: Random.value(),
                        });
                    }

                    break;
                case CardModifierType.bomb:
                    if (
                        modifierComponent.properties.timer !==
                        modifier.properties.timer
                    ) {
                        const animations = [
                            'explosion',
                            'countdown1',
                            'countdown2',
                            'countdown3',
                            'countdown4',
                            'countdown5',
                        ];

                        // Trigger animation..
                        StartAnimation(
                            modifierGameObject.find('bombContainer'),
                            'DragonbonesDefault',
                            {
                                animationName:
                                    animations[modifier.properties.timer],
                            }
                        );

                        StartAudio(
                            cardSystem.scene,
                            AUDIO_HAZARD_BOMB_COUNT,
                            AudioTrackType.SFX
                        );
                    }

                    break;
                case CardModifierType.ice:
                    /*
                        if (modifier.properties.plays > 0) {
                            modifierGameObject
                                .getChildByName('iceSprite')
                                .getComponent(SpriteComponent).visible = false;
                        }
                        */
                    break;
                case CardModifierType.lowering:
                    break;
                case CardModifierType.rising:
                    break;
                case CardModifierType.water:
                    break;
                case CardModifierType.algae:
                    /*
                        const algaeSprite = modifierGameObject
                            .getChildByName('algaeSprite')
                            .getComponent(SpriteComponent);
                        if (modifier.properties.plays > 2) {
                            algaeSprite.visible = false;
                        } else {
                            algaeSprite.visible = true;
                            algaeSprite.texture = [
                                'algae_3',
                                'algae_2',
                                'algae_1',
                            ][modifier.properties.plays];
                        }
                        */
                    break;
            }

            // Update modifier component properties.
            modifierComponent.properties = modifier.properties;
        });
    }

    public handleCardFolded(state: IGameState, cardSystem: CardSystem) {
        super.handleCardFolded(state, cardSystem);

        this.setCardModifiersVisible(false);
    }

    public setCardFaceUp(faceUp: boolean) {
        super.setCardFaceUp(faceUp);

        if (
            this.card.getComponent(CardComponent).currentStatus ===
            CardStatus.IN_PLAY
        ) {
            this.setCardModifiersVisible(faceUp);
            if (this.card.getComponent(CardComponent).type === CardType.gold) {
                this.setCardAnimationVisible(faceUp);
            }
        } else {
            this.setCardModifiersVisible(false);
        }
    }
}
